import { ConditionalFormattingConditionType } from "../store/schema/ConditionalFormattingConditionType";

// Define conflict rules: Map each condition type to the set of types it conflicts with
const CONFLICT_RULES = new Map<ConditionalFormattingConditionType, ReadonlySet<ConditionalFormattingConditionType>>([
    [
        ConditionalFormattingConditionType.OnTheToLine,
        new Set([
            ConditionalFormattingConditionType.NotOnTheToLine,
            ConditionalFormattingConditionType.OnTheToOrCcLine,
        ]),
    ],
    [
        ConditionalFormattingConditionType.OnTheCcLine,
        new Set([ConditionalFormattingConditionType.OnTheToOrCcLine]),
    ],
    [
        ConditionalFormattingConditionType.NotOnTheToLine,
        new Set([
            ConditionalFormattingConditionType.OnTheToLine,
            ConditionalFormattingConditionType.OnTheToOrCcLine,
        ]),
    ],
    [
        ConditionalFormattingConditionType.OnTheToOrCcLine,
        new Set([
            ConditionalFormattingConditionType.OnTheToLine,
            ConditionalFormattingConditionType.OnTheCcLine,
            ConditionalFormattingConditionType.NotOnTheToLine,
        ]),
    ],
    [
        ConditionalFormattingConditionType.ReadItems,
        new Set([ConditionalFormattingConditionType.UnreadItems]),
    ],
    [
        ConditionalFormattingConditionType.UnreadItems,
        new Set([ConditionalFormattingConditionType.ReadItems]),
    ],
    [
        ConditionalFormattingConditionType.WithAttachments,
        new Set([ConditionalFormattingConditionType.WithoutAttachments]),
    ],
    [
        ConditionalFormattingConditionType.WithoutAttachments,
        new Set([ConditionalFormattingConditionType.WithAttachments]),
    ],
    [
        ConditionalFormattingConditionType.BetweenSize,
        new Set([
            ConditionalFormattingConditionType.LowerThanSize,
            ConditionalFormattingConditionType.GreaterThanSize,
        ]),
    ],
    [
        ConditionalFormattingConditionType.LowerThanSize,
        new Set([
            ConditionalFormattingConditionType.BetweenSize,
            ConditionalFormattingConditionType.GreaterThanSize,
        ]),
    ],
    [
        ConditionalFormattingConditionType.GreaterThanSize,
        new Set([
            ConditionalFormattingConditionType.BetweenSize,
            ConditionalFormattingConditionType.LowerThanSize,
        ]),
    ],
    [
        ConditionalFormattingConditionType.ImportanceHigh,
        new Set([
            ConditionalFormattingConditionType.ImportanceNormal,
            ConditionalFormattingConditionType.ImportanceLow,
            ConditionalFormattingConditionType.ImportanceCopilotPrioritized,
        ]),
    ],
    [
        ConditionalFormattingConditionType.ImportanceNormal,
        new Set([
            ConditionalFormattingConditionType.ImportanceHigh,
            ConditionalFormattingConditionType.ImportanceLow,
            ConditionalFormattingConditionType.ImportanceCopilotPrioritized,
        ]),
    ],
    [
        ConditionalFormattingConditionType.ImportanceLow,
        new Set([
            ConditionalFormattingConditionType.ImportanceHigh,
            ConditionalFormattingConditionType.ImportanceNormal,
            ConditionalFormattingConditionType.ImportanceCopilotPrioritized,
        ]),
    ],
    [
        ConditionalFormattingConditionType.ImportanceCopilotPrioritized,
        new Set([
            ConditionalFormattingConditionType.ImportanceHigh,
            ConditionalFormattingConditionType.ImportanceNormal,
            ConditionalFormattingConditionType.ImportanceLow,
        ]),
    ],
    [
        ConditionalFormattingConditionType.FlaggedItems,
        new Set([
            ConditionalFormattingConditionType.UnflaggedItems,
            ConditionalFormattingConditionType.MarkedAsCompleted,
        ]),
    ],
    [
        ConditionalFormattingConditionType.UnflaggedItems,
        new Set([
            ConditionalFormattingConditionType.FlaggedItems,
            ConditionalFormattingConditionType.MarkedAsCompleted,
        ]),
    ],
    [
        ConditionalFormattingConditionType.MarkedAsCompleted,
        new Set([
            ConditionalFormattingConditionType.FlaggedItems,
            ConditionalFormattingConditionType.UnflaggedItems,
        ]),
    ],
]);

export function hasConflictsWithAppliedCondition(currentConditionType: ConditionalFormattingConditionType, appliedCondition: ConditionalFormattingConditionType): boolean {
    if (appliedCondition == null || currentConditionType == null) {
        return false;
    }
    return CONFLICT_RULES.get(appliedCondition)?.has(currentConditionType) ?? false;
}
